import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { toggleswitchPreset } from './components/toggleswitch.preset';
import { datepickerPreset } from './components/datepicker.preset';
import { inputtextPreset } from './components/inputtext.preset';
import { checkboxPreset } from './components/checkbox.preset';
import { textareaPreset } from './components/textarea.preset';
import { selectPreset } from './components/select.preset';
import { menubarPreset } from './components/menubar.preset';
import { breadcrumbPreset } from './components/breadcrumb.preset';
import { buttonPreset } from './components/button.preset';
import { dialogPreset } from './components/dialog.preset';
import { chipPreset } from './components/chip.preset';
import { cardPreset } from './components/card.preset';
import { floatlabelPreset } from './components/floatlabel.preset';
import { multiselectPreset } from './components/multiselect.preset';
import { accordionPreset } from './components/accordion.preset';
import { Colors } from './preset.constants';
import { tagPreset } from './components/tag.preset';

export const AlveriCmsPreset = definePreset(Aura, {
    darkMode: false,
    semantic: {
        colorScheme: {
            light: {
                background: {
                    0: Colors.SecondaryBackground // page background
                },
                surface: {
                    0: Colors.PrimaryBackground // card/input background
                    // 100: '#eeeeee', // hover or elevated surface
                    // 200: '#dddddd' // borders or subtle elevation
                },
                primary: {
                    500: Colors.Primary
                },
                secondary: {
                    500: Colors.Secondary
                },
                textPrimary: Colors.DefaultTextColor,
                textSecondary: Colors.DisabledColor,
                success: Colors.SuccessColor,
                info: Colors.Info,
                warning: '#fb8c00',
                danger: Colors.Danger
            }
        }
    },
    components: {
        toggleswitch: toggleswitchPreset,
        datepicker: datepickerPreset,
        inputtext: inputtextPreset,
        checkbox: checkboxPreset,
        textarea: textareaPreset,
        select: selectPreset,
        menubar: menubarPreset,
        breadcrumb: breadcrumbPreset,
        button: buttonPreset,
        dialog: dialogPreset,
        chip: chipPreset,
        card: cardPreset,
        floatlabel: floatlabelPreset,
        multiselect: multiselectPreset,
        accordion: accordionPreset,
        tag: tagPreset
    }
});